import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom"; // ✅ no BrowserRouter here
import api from "./api";
import { AuthProvider } from "./auth/AuthContext";
import Layout from "./layout/Layout";
import Home from "./Home";
import CategoryPage from "./products/CategoryPage";
import BrandPage from "./products/BrandPage";
import ProductDetailPage from "./products/ProductDetailPage";
import CartBar from "./cart/CartBar";
import { CartProvider } from "./cart/CartContext";
import CartPage from "./cart/CartPage";
import LoginPage from "./auth/LoginPage";
import RegistrationPage from "./auth/RegistrationPage";
import UpdateProfilePage from "./auth/UpdateProfilePage";
import ChangePasswordPage from "./auth/ChangePasswordPage";
import ForgotPasswordPage from "./auth/ForgotPasswordPage";
import BulkAndImprinting from "./quote/BulkAndImprinting";
import { PageProvider } from "./context/PageContext";
import PageView from "./pages/PageView";
import QuotesPageContainer from "./quote/QuotesPageContainer";
import { QuoteProvider } from "./quote/QuoteContext";
import QuoteRequest from "./quote/QuoteRequest";
import QuoteSuccess from "./quote/QuoteSuccess";
import SearchPage from "./products/SearchPage";
import CheckoutFailed from "./order/CheckoutFailed";
import CheckoutSuccess from "./order/CheckoutSuccess";
import MyOrders from "./order/MyOrders";
import ProtectedRoute from "./ProtectedRoute";
import ResetPassword from './auth/ResetPasswordPage';
import BrandList from "./products/BrandList";
import SizeBrandList from "./products/SizeBrandList";
import ReturnByOrder from "./order/ReturnByOrder";
import ScrollToTop from "./ScrollToTop";
import WeeklyDeals from "./products/WeeklyDeals";
function App() {
  const [headers, setHeaders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
 
  useEffect(() => {
    api.get("/sanctum/csrf-cookie").catch((err) => {
      console.error("CSRF cookie fetch failed:", err);
    });
  }, []);

  useEffect(() => {
    const fetchNavigation = async () => {
      try {
        const navRes = await api.get("/api/navigation");
        const formattedHeaders = navRes.data.map((h) => ({
          id: h.id,
          name: h.name,
          all_subheaders: h.all_subheaders || h.children || [],
        }));
        setHeaders(formattedHeaders);
      } catch (err) {
        console.error("Failed to fetch navigation:", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchNavigation();
  }, []);

  return (
    <AuthProvider>
    <PageProvider>
       <QuoteProvider>
      <CartProvider>
        <Layout headers={headers} isLoading={isLoading}>
          <CartBar />
          <ScrollToTop />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/registration" element={<RegistrationPage />} />
            
            <Route path="/" element={<Home />} />
            <Route path="/category/:type/:name" element={<CategoryPage />} />
            <Route path="/products/brand/:name" element={<BrandPage />} />
            <Route path="/products/:id/:name" element={<ProductDetailPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/quotes" element={<BulkAndImprinting />} />
            <Route path="/:slug" element={<PageView />} />
            <Route path="/my-quotes" element={<QuotesPageContainer />} />
            <Route path="/quote-request" element={<QuoteRequest />} />
            <Route path="/quote-success" element={<QuoteSuccess />} />
            <Route path="/search/:query" element={<SearchPage />} />
            <Route path="/checkout-success" element={<CheckoutSuccess />} />
            <Route path="/checkout-failed" element={<CheckoutFailed />} />
            <Route path="/orders" element={<MyOrders />} />
            <Route path="*" element={<div>Page Not Found</div>} />
             {/* Protected Routes */}
            <Route path="/update-profile" element={ <ProtectedRoute> <UpdateProfilePage /> </ProtectedRoute> } />
            <Route path="/change-password" element={ <ProtectedRoute> <ChangePasswordPage /> </ProtectedRoute> } />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/brands" element={<BrandList />} />
            <Route path="/sizechart-brands" element={<SizeBrandList />} />
            <Route path="/return-order" element={<ReturnByOrder />} />
            <Route path="/weekly-deals" element={<WeeklyDeals />} />
          </Routes>
        </Layout>
      </CartProvider>
      </QuoteProvider>
    </PageProvider>
    </AuthProvider>
  );
}

export default App;
